import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import * as _ from 'lodash';
import AddCircleLocation from "../AddCircleLocation/AddCircleLocation.vue";
import EditCircleLocation from "../EditCircleLocation/EditCircleLocation.vue";
import EmptyFeed from "@/components/Main/EmptyFeed/EmptyFeed.vue";
import swal from "sweetalert";
import CircleService from "@/services/circle";
import FileUtils from "@/utils/file";
import RandomValues from "@/utils/random";
import { ModelListSelect } from "vue-search-select";
import router from "@/router";

const circleService = new CircleService();
const fileUtils = new FileUtils();
const randomValues = new RandomValues();

export default {
  name: "CircleSettings",
  props: ["circle", "user", "isUserAdmin"],
  components: { "popper": Popper, AddCircleLocation, EmptyFeed, EditCircleLocation, ModelListSelect },
  data() {
    return {
      popperOptions: {
        placement: "top",
        modifiers: { offset: { offset: "0,10px" } }
      },
      selectedLocation: null,
      title: this.$props.circle.title,
      visibilityValue: this.circle.flags.find(s => s.type === "visibility").value,
      circleType: this.circle.flags.find(s => s.type === "type").value,
      circleIcon: null,
      newRequirement: "",
      selectedMemberID: null,
      selectedRole: null,
      selectedMemberID1: null,
      tagSwitch: false,
      tagText: "",
      tags: ["Yes", "No", "Other"],
      newTagText: {},
      updateReq: null,
      vanity: null,
      vanityText: ''
    }
  },
  computed: {
    members: function () {
      const board = this.$props.circle.board || this.$props.circle.boards || [];
      return board.filter(s => s.status === "default");
    },
    allMembers: function () {
      const board = this.$props.circle.board || this.$props.circle.boards || [];
      return board.filter(s => s.profile_id !== this.$props.user._id);
    },
    admins: function () {
      const board = this.$props.circle.board || this.$props.circle.boards || [];
      return board.filter(s => s.status !== "default");
    },
    selectedMember: function () {
      let member;
      if (this.selectedMemberID) {
        const board = this.$props.circle.board || this.$props.circle.boards || [];
        member = board.filter(s => s.status === "default").find(s => s._id === this.selectedMemberID);
      }
      return member;
    },
    selectedMember1: function () {
      let member;
      if (this.selectedMemberID1) {
        const board = this.$props.circle.board || this.$props.circle.boards || [];
        member = board.filter(s => s.profile_id !== this.$props.user._id).find(s => s._id === this.selectedMemberID1);
      }
      return member;
    },
    visibility: function () {
      return this.circle.flags.find(s => s.type === "visibility");
    }
  },
  watch: {
    tagText(newText, prevText) {
      let input = this.tagText.split(",");
      if (input.length < 2) return;
      this.addTag(input[0]);
    }
  },
  methods: {
    removeLocation(location) {
      swal({
        text: `Remove "${location.title}" location?`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          circleService.deleteLocation(location._id)
            .then(() => {
              this.$notification.new("Location removed");
              this.$root.$emit("RemoveCircleLocation", location);
            })
            .catch(err => this.$root.$emit("ShowErrorNotification", err.message));
        }
      })
    },
    renameCircle(e) {
      if (this.title !== this.$props.circle.title) {
        swal({
          text: `Rename circle?`,
          icon: "warning",
          buttons: true,
        }).then((willRename) => {
          if (willRename) {
            const btn = e.srcElement;
            btn.innerText = "Processing";
            btn.disabled = true;
            btn.classList.add("btn--loading");

            const form = {
              _id: this.$props.circle._id,
              title: this.title,
              upload_id: this.$props.circle.upload_id,
              status: "active"
            };

            const successAction = function () {
              btn.innerText = "Change";
              btn.classList.remove("btn--loading");
              btn.disabled = false;
              this.$notification.new("Circle title changed");
            }

            const failureAction = function (response) {
              btn.innerText = "Change";
              btn.classList.remove("btn--loading");
              btn.disabled = false;
              this.$root.$emit("ShowErrorNotification", response.message);
            }

            circleService.editCircle(form).then((circle) => {
              this.$root.$emit("SaveModifiedCircle", circle);
              successAction.call(this);
            }).catch(err => failureAction.call(this, err));
          }
        });
      }
    },
    changeCircleVisibility(e) {
      if (this.visibilityValue !== this.visibility.value) {
        const btn = e.srcElement;
        btn.innerText = "Processing";
        btn.disabled = true;
        btn.classList.add("btn--loading");

        const successAction = function () {
          btn.innerText = "Change";
          btn.classList.remove("btn--loading");
          btn.disabled = false;
          this.$notification.new(`Circle is now ${this.visibilityValue}`);
        }

        const failureAction = function (response) {
          btn.innerText = "Change";
          btn.classList.remove("btn--loading");
          btn.disabled = false;
          this.$root.$emit("ShowErrorNotification", response.message);
        }

        const form = {
          _id: this.visibility._id,
          type: this.visibility.type,
          value: this.visibilityValue,
          status: this.visibility.status,
          circle_id: this.visibility.circle_id
        };

        circleService.editCircleFlag(form).then((flag) => {
          this.$root.$emit("SaveModifiedCircleFlag", flag);
          successAction.call(this);
        }).catch(err => failureAction.call(this, err));
      }
    },
    selectIconFromFS() {
      const hiddenIconInput = document.getElementById("icon-input");
      hiddenIconInput.click();
    },
    async iconSelectCallback(e) {
      const files = e.target.files || e.dataTransfer.files;
      const validationStatus = fileUtils.validateFile(files);
      if (validationStatus.valid) {
        this.circleIcon = {
          id: randomValues.secureRandString(),
          circle: this.$props.circle,
          file: files[0],
          src: await fileUtils.getSrc(files)
        };
        swal({
          text: `Change circle icon?`,
          icon: "warning",
          buttons: true,
        }).then((willRename) => {
          if (willRename) {
            circleService.changeCircleIcon(this.circleIcon).then((circle) => {
              this.circleIcon = null;
              this.$root.$emit("SaveModifiedCircleIcon", circle);
              this.$notification.new("Circle icon changed");
            }).catch(err => this.$root.$emit("ShowErrorNotification", err.message));
          } else {
            this.circleIcon = null;
          }
        });
      } else {
        this.$root.$emit("ShowErrorNotification", validationStatus.message);
      }
    },
    removeRequirement(requirement) {
      swal({
        text: `Remove "${requirement.title}" requirement?`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          circleService.deleteIdentity(requirement._id)
            .then(() => {
              this.$notification.new("Requirement deleted");
              this.$root.$emit("RemoveCircleRequirement", requirement);
            })
            .catch(err => this.$root.$emit("ShowErrorNotification", err.message));
        }
      })
    },
    addRequirement(value, tags, e) {
      const submitBtn = e.srcElement;

      swal({
        text: `Add "${value}" requirement?`,
        icon: "warning",
        buttons: true,
      }).then((willAdd) => {
        if (willAdd) {
          const form = {
            title: value,
            status: "active",
            circle_id: this.$props.circle._id,
            tags: Array.from(tags)
          };
          submitBtn.disabled = true;

          circleService.addIdentity(form).then((requirement) => {
            this.newRequirement = "";
            this.$notification.new("Requirement added");
            this.$root.$emit("AddCircleRequirement", requirement);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    memberName(member) {
      return member.profile.name;
    },
    addAdmin(member, role, e) {
      const submitBtn = e.srcElement;

      swal({
        text: `Make ${member.profile.name} an ${role}?`,
        icon: "warning",
        buttons: true,
      }).then((willMakeAdmin) => {
        if (willMakeAdmin) {
          submitBtn.disabled = true;

          circleService.changeMemberRole(member, role).then((updated_member) => {
            this.selectedRole = null;
            this.selectedMemberID = null;

            this.$notification.new(`${member.profile.name} is now an ${role}`);
            this.$root.$emit("ChangeMemberRole", updated_member);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    removeAdmin(member, e) {
      const submitBtn = e.srcElement;
      const oldRole = member.status;

      swal({
        text: `Remove ${member.profile.name} an ${oldRole}?`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((removeAsAdmin) => {
        if (removeAsAdmin) {
          submitBtn.disabled = true;

          circleService.changeMemberRole(member, "default").then((updated_member) => {
            this.$notification.new(`${member.profile.name} is no longer an ${oldRole}`);
            this.$root.$emit("ChangeMemberRole", updated_member);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    removeMember(member, e) {
      const submitBtn = e.srcElement;
      swal({
        text: `Remove ${member.profile.name} from this circle?`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((removeMember) => {
        if (removeMember) {
          submitBtn.disabled = true;

          circleService.removeMember(member).then(() => {
            this.$notification.new(`${member.profile.name} has been removed from this circle`);
            this.$root.$emit("RemoveMemberFromCircle", member);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    deleteCircle(e) {
      const submitBtn = e.srcElement;
      swal({
        text: `Delete this circle? This action cannot be reversed.`,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((deleteCircle) => {
        if (deleteCircle) {
          submitBtn.disabled = true;

          circleService.deleteCircle(this.$props.circle._id).then(() => {
            this.$notification.new(`The "${this.$props.circle.title}" circle has been permanently deleted`);
            router.replace({ path: "/feed" });
            this.$root.$emit("DeleteCircle", this.$props.circle);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    handleTagChange(e) {
      if (this.tagText === "" && e.keyCode === 8) {
        this.tags.splice(-1, 1);
      }
      if (this.tagText !== "" && e.keyCode === 13) {
        this.addTag(e.target.value);
      }
    },
    addTag(value) {
      var tags_array = Object.assign([], this.tags);
      tags_array.push(value);
      this.tags = _.uniq(tags_array);
      this.tagText = "";
    },
    deleteTag(index) {
      this.tags.splice(index, 1);
    },
    handleTagSwitch(e) {
      this.tagSwitch = e.target.checked;
    },
    addIdentityTag(req, value, e) {
      //
      console.log('add')
      const submitBtn = e.srcElement;

      swal({
        text: `Add "${value}" as an answer?`,
        icon: "warning",
        buttons: true,
      }).then((willAdd) => {
        if (willAdd) {
          const form = {
            identity_id: req._id,
            value
          };
          submitBtn.disabled = true;
          circleService.addIdentityTag(form).then((requirement) => {
            this.newTagText[req._id] = "";
            this.$notification.new("Requirement answer added");
            // this.$root.$emit("AddCircleRequirement", requirement);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    removeIdentityTag(tag, e) {
      const submitBtn = e.srcElement;

      swal({
        text: `Remove "${tag.value}" answer?`,
        icon: "warning",
        buttons: true,
      }).then((willAdd) => {
        if (willAdd) {
          const form = { ...tag };
          submitBtn.disabled = true;

          circleService.removeIdentityTag(form).then((requirement) => {
            this.$notification.new("Requirement answer removed");
            // this.$root.$emit("AddCircleRequirement", requirement);
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    updateRequirement(e) {
      let req = this.updateReq
      const submitBtn = e.srcElement;
      swal({
        text: `Update requirement?`,
        icon: "warning",
        buttons: true,
      }).then((willAdd) => {
        if (willAdd) {
          const form = {
            _id: req._id,
            title: req.title,
            circle_id: req.circle_id,
            status: req.status,
          };
          submitBtn.disabled = true;
          circleService.updateIdentity(form).then((requirement) => {
            this.updateReq = null;
            this.$notification.new("Requirement updated");
            this.$root.$emit("AddCircleRequirement", requirement);
            $('#updateRequirementModal').modal('hide')
          }).catch(err => {
            submitBtn.disabled = false;
            this.$root.$emit("ShowErrorNotification", err.message);
          });
        }
      })
    },
    openReqModal(req) {
      this.updateReq = { ...req }
      $('#updateRequirementModal').modal('show')
    },
    closeReqModal() {
      $('#updateRequirementModal').modal('hide')
      this.updateReq = null
    },
    publishVanity(action, type) {
      if (!this.vanityText || this.vanityText === '') {
        return
      }
      if (this.vanity && this.vanityText === this.vanity.identity && this.vanity.type === type) {
        return
      }

      let pushData = null
      switch (action) {
        case 'publish':
          // attempt a create or save
          if (this.vanity) {
            // update
            pushData = {
              _id: this.vanity._id,
              parent_id: this.vanity.parent_id,
              type: type,
              identity: this.vanityText,
            }
            circleService.updateVanity(pushData).then(res => {
              // update vue-instance vanity
              this.vanity = pushData
            }).catch(err => {
            })
          } else {
            // create
            pushData = {
              parent_id: this.$props.circle._id,
              type: type,
              identity: this.vanityText,
            }
            circleService.createVanity(pushData).then(res => {
              // update vue-instance vanity
              pushData['_id'] = res
              this.vanity = pushData
            }).catch(err => {
            })
          }
          break;

        case 'swap':
          // attempt a type swap
          pushData = {...this.vanity}
          if(pushData['type'] === 'circle-gene-in') {
            pushData['type'] = 'circle-polly-out'
          } else {
            pushData['type'] = 'circle-gene-in'
          }
          circleService.updateVanity(data).then(res => {
            this.vanity = pushData
          })
          break;

        default:
          return
          break;
      }
    },
    deleteVanity() { 
      
      swal({
        title: 'Thread with caution.',
        text: 'Users will no longer have access to this circle via this vanity link. Withdraw vanity link? ',
        content: '',
        className: 'px-4',
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          circleService.deleteVanity({_id: this.vanity._id})
            .then(() => {
              this.$notification.new("Vanity URL removed");
              this.vanity = null
              this.vanityText = ''
            })
            .catch(err => this.$root.$emit("ShowErrorNotification", err.message));
        }
      })
    }
  },
  mounted() {
    circleService.getCircleVanity(this.$props.circle._id).then(res => {
      if (res) {
        this.vanity = res
        this.vanityText = res.identity
      }
    }).catch(err => {
      console.log(err)
    })
  }
}